// -> IExportManager.OpenArtifactAsync (ArtifactsController). The one download route, and it
// re-authorizes every time (ArtifactsController.cs).
import { httpDownload } from "./http";

export const artifactsApi = {
  download: (artifactKey: string) => httpDownload(`/api/artifacts/${artifactKey}`),
};

/** Triggers a browser save of a downloaded artifact Blob, using the file name the server sent. */
export function saveBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  try {
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.click();
  } finally {
    URL.revokeObjectURL(url);
  }
}
